import { Controller } from "@hotwired/stimulus"

// Click-to-toggle dropdown menu with click-outside dismissal. Used for the company
// page "Actions" menu. (BT's bundled desktop_menu controller is hover-based, which
// isn't right for an actions menu.)
export default class extends Controller {
  static targets = ["menu", "trigger"]

  connect() {
    this.boundClickOutside = this.clickOutside.bind(this)
    this.boundKeydown = this.keydown.bind(this)
    document.addEventListener("click", this.boundClickOutside)
    document.addEventListener("keydown", this.boundKeydown)
    this.updateDisclosureState()
  }

  disconnect() {
    document.removeEventListener("click", this.boundClickOutside)
    document.removeEventListener("keydown", this.boundKeydown)
  }

  toggle(event) {
    event.stopPropagation()
    this.menuTarget.classList.toggle("hidden")
    this.updateDisclosureState()
  }

  clickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  keydown(event) {
    if (event.key !== "Escape" || this.menuTarget.classList.contains("hidden")) return

    event.preventDefault()
    event.stopPropagation()
    this.close()
    if (this.hasTriggerTarget) this.triggerTarget.focus()
  }

  close() {
    this.menuTarget.classList.add("hidden")
    this.updateDisclosureState()
  }

  updateDisclosureState() {
    if (!this.hasTriggerTarget) return

    const expanded = !this.menuTarget.classList.contains("hidden")
    this.triggerTarget.setAttribute("aria-expanded", String(expanded))
  }
}
